import React, { createContext, useRef, useState } from "react";

export const ToastContext = createContext();

const normalizeToastVariant = (type) => {
  if (typeof type === "string" && type.trim()) {
    return type === "error" ? "danger" : type;
  }

  if (type && typeof type === "object") {
    const candidate =
      type.variant || type.appearance || type.bg || type.type || "info";
    return typeof candidate === "string" && candidate.trim()
      ? candidate === "error"
        ? "danger"
        : candidate
      : "info";
  }

  return "info";
};

export const ToastProvider = ({ children }) => {
  const [toastMessages, setToastMessages] = useState([]);
  const toastCounterRef = useRef(0);

  const addToast = (
    message = {},
    type = "info",
    duration = 5000,
    options = {},
  ) => {
    const normalizedMessage =
      typeof message === "string" ? { message } : message || {};
    const normalizedType = normalizeToastVariant(type);
    const toastId =
      normalizedMessage.id ||
      `toast-${Date.now()}-${toastCounterRef.current++}`;

    setToastMessages((prev) => [
      ...prev,
      {
        ...normalizedMessage,
        ...options,
        id: toastId,
        variant: normalizedType,
        delay: duration,
      },
    ]);
    //  Auto-remove after duration
    setTimeout(() => removeToast(toastId), duration);
  };

  const removeToast = (id) => {
    setToastMessages((prev) => prev.filter((toast) => toast.id !== id));
  };

  const value = {
    toastMessages,
    addToast,
    removeToast,
  };

  return (
    <ToastContext.Provider value={value}>{children}</ToastContext.Provider>
  );
};
